import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=a3d48ff2"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=a3d48ff2&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3d48ff2')) {
      api.createRecord('a3d48ff2', component.options)
    } else {
      api.reload('a3d48ff2', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=a3d48ff2", function () {
      api.rerender('a3d48ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/sidebar.vue"
export default component.exports